export default __webpack_public_path__ + "static/media/Logo.a6168ba9.png";